import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import { browserHistory } from 'react-router'
import { user } from './user'

var WorkOrder = Class.create({
  	initialize: function() {
	},
	getWorkOrder: function(workOrderID, callback) {
		var self = this;
		var url = "maintenance/order/" + workOrderID;
		var data = server.getData(url,null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
		});
    },
    workOrderComplete: function(orderData, callback) {
        modal.showDangerModalWithOK("Are you sure?","You are about to mark this work order complete.","Yes, Complete");
        jQuery(".move-on").on('click',function() {
            var url = "maintenance/order/" + orderData.work_order_id + "/update";
            var params = orderData;
            var data = server.getData(url, params, true, 'PUT');
            data
            .done(function(response){
                if(response.data.error_user_authentication == 1)
                {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2))
                {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                } else {
                    if(callback) {
                        modal.showInfo("Work Order has been marked as completed!", "success", "top", "center");
                        callback(response);
                    }
                }
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
        });
    },
    updateWorkOrder: function(orderData, callback) {
        modal.showDangerModalWithOK("Are you sure?","You are about to update this work order.","Yes, Update");
        jQuery(".move-on").on('click',function() {
            var url = "maintenance/order/" + orderData.work_order_id + "/update";
            var params = orderData;
            var data = server.getData(url, params, true, 'POST');
            data
            .done(function(response){
                if(response.data.error_user_authentication == 1)
                {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2))
                {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                } else {
                    modal.resetBackDrop();
                    modal.showSuccess("Work Order Updated!","This work order has been successfully updated.");
                    if(callback) {
                        callback(response);
                    }
                }
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
        });
    },
    deleteWorkOrder: function(workOrderID) {
        var self = this;
        modal.showDangerModalWithOK("Are you sure?","You are about to delete this work order.","Yes, Delete");
        jQuery(".move-on").on('click',function() {
            var url = "maintenance/order/" + workOrderID;
            var params = data;
            var data = server.getData(url, params, true, 'DELETE');
            data
            .done(function(response){
                if(response.data.error_user_authentication == 1)
                {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2))
                {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                } else {
                    modal.resetBackDrop();
                    modal.showSuccess("Work Order Deleted!","This work order has been dropped. All associated information with this work order has been removed and any associated contractors have been notified.");
                    jQuery(".move-on").on('click',function() {
                        browserHistory.goBack();
                    });
                }
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
        });
    },
    saveWorkOrder: function(orderData, callback) {
        var url = "maintenance/order/";
        if(user.userInfo.user_type_alias == 'tenant') {
            url = 'maintenance/tenant/order';
        }

        var params = orderData;
        var data = server.getData(url, params, true, 'POST');
        data
        .done(function(response){
            if(response.data.error_user_authentication == 1)
            {
            }
            else if(response.data.error || (response.status == 1 || response.status == 2))
            {
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
            } else {
                if(callback) {
                    callback(response.data.work_order_id);
                }
            }
        })
        .fail(function(e){
            modal.resetBackDrop();
            modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
        });
    },
});

export let workOrder = new WorkOrder();


// WEBPACK FOOTER //
// app/core/controllers/WorkOrder.js